import React from 'react';
import { hasAtLeastOneChecked } from 'app/util/validators';
import { RadioWithCheckboxPanel } from 'app/components/FormFields/RadioWithCheckboxPanel';
import { FieldNames } from 'app/models/fields/names';
import { HOME_EQUITY_DEBT_CONSOLIDATION_OPTIONS } from 'app/models/options/options';
import { HomeEquityLoanPurpose } from '@lenderful/domain';

/**
 * Home equity loan purpose radios. When the client hides the `PAYOFF` option, choosing Debt Consolidation shows
 * a "What are you consolidating?" checkbox panel instead.
 */
export const HomeEquityLoanPurposeRadio = (props: any) => {
  const isPanelEnabled = !!props.excludedOptions?.includes('PAYOFF');

  return (
    <RadioWithCheckboxPanel
      isPanelEnabled    = {isPanelEnabled}
      name              = {props.name}
      onChange          = {props.onChange}
      options           = {props.options}
      panelName         = {FieldNames.homeEquityDebtConsolidationType}
      panelOptions      = {HOME_EQUITY_DEBT_CONSOLIDATION_OPTIONS}
      panelTitle        = 'What are you consolidating?'
      panelTriggerValue = {HomeEquityLoanPurpose.CONSOLIDATION}
      panelValidate     = {[hasAtLeastOneChecked]}
      values            = {props.values}
    />
  );
};
